<template>
  <VRow no-gutters>
    <VCol v-if="sent" cols="12">
      <span>{{ $t('successMessage') }}</span>
    </VCol>
    <VCol v-else cols="12">
      <VTextarea
        v-model="message"
        outlined
        :hide-details="!error.errors.message"
        :error-messages="error.errors.message"
        rows="3"
        background-color="#fff"
        @input="error.errors.message = null"
      >
        <template #label>
          <span class="body-2 grey--text">
            {{ $t('tip') }}
          </span>
        </template>
      </VTextarea>
      <div class="mt-6 text-center">
        <VBtn
          color="primary"
          class="white--text mr-4"
          :loading="isLoading"
          @click="submit"
        >
          {{ $t('send') }}
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>

<script>
import ApiMixin from '../mixins/ApiMixin';

export default {
  name: 'CandidateFeedbackForm',
  mixins: [ApiMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      message: null,
      error: {
        errorMessage: null,
        errors: {},
      },
      sent: false,
      isLoading: false,
    };
  },
  computed: {
    hasErrorMessageOnly() {
      return !Object.keys(this.error.errors).length && this.error.errorMessage;
    },
  },
  methods: {
    async submit() {
      try {
        await this.withApiErrorHandling(async () => {
          await this.$store.dispatch('candidate/feedback', {
            candidateId: this.candidateId,
            message: this.message,
          });
          this.sent = true;
          this.$emit('sent');
        }, 'error', 'isLoading');
      } catch (e) {
        if (this.hasErrorMessageOnly) {
          this.$toast.error(this.error.errorMessage);
        }
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  tip: "Please specify the reason. This will help us make our service better!"
  send: Send
  successMessage: Thanks for the feedback
</i18n>

<i18n locale="ru" lang="yaml">
  tip: "Пожалуйста, уточните причину отказа. Это поможет нам сделать сервис лучше!"
  send: Отправить
  successMessage: Спасибо за обратную связь
</i18n>
